import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const MyAccessCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacing.horizontalMedium};
  margin-bottom: ${tokens.spacing.verticalMedium};

  p {
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.regular};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
    margin: 0;
  }

  h4 {
    display: none;
  }

  @media only screen and (min-width: ${tokens.breakpoints.desktop}px) {
    h4 {
      display: block;
      font-size: ${tokens.fontSize.large};
      font-weight: ${tokens.fontWeights.bold};
      line-height: ${tokens.lineHeight.medium}%;
      color: ${tokens.colors.dark6};
      margin: 0 0 ${tokens.spacing.verticalSmall} 0;
    }
  }
`

export const InfoJobPositionAndRoleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${tokens.spacing.verticalSmall};
  margin-bottom: ${tokens.spacing.verticalXxlarge};
`

export const InfoWrapper = styled.div`
  width: 100%;
  margin-bottom: ${tokens.spacing.verticalXxlarge};

  h5 {
    color: ${tokens.colors.dark6};
    margin: ${tokens.spacing.verticalXxsmall} 0 ${tokens.spacing.verticalSmall};
  }

  & > p {
    margin-bottom: ${tokens.spacing.verticalLarge};
  }
`

export const ClassesSelectionContainer = styled.div`
  display: flex;
  gap: ${tokens.spacing.horizontalLarge};
  width: 100%;
  margin-top: ${tokens.spacing.verticalMedium};

  @media only screen and (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: column;
  }
`

export const ClassesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 330px;
  height: 400px;
  border-radius: 10px;
  border: 1px solid ${tokens.colors.dark2};
  padding: ${tokens.spacing.insetMedium};
  background: ${tokens.colors.white};
  overflow: hidden;

  @media only screen and (max-width: ${tokens.breakpoints.tablet}px) {
    max-width: 100%;
  }
`

export const ClassesList = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

export const ClassesListTitle = styled.div`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
  margin-bottom: ${tokens.spacing.verticalMedium};
  text-align: center;
`

export const ClassItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${tokens.spacing.verticalSmall} ${tokens.spacing.horizontalSmall};
  border-bottom: 1px solid ${tokens.colors.paleGreyFour};
  gap: ${tokens.spacing.horizontalSmall};

  &:last-child {
    border-bottom: none;
  }
`

export const ClassesSelectedsSpan = styled.span`
  font-size: ${tokens.fontSize.xsmall};
  font-weight: ${tokens.fontWeights.regular};
  line-height: ${tokens.lineHeight.small}%;
  color: ${tokens.colors.dark5};
  margin-top: ${tokens.spacing.verticalSmall};
  padding-top: ${tokens.spacing.verticalSmall};
  border-top: 1px solid ${tokens.colors.paleGreyFour};
  text-align: center;
`

export const InfoUserWrapper = styled.div`
  width: 100%;
  background: ${tokens.colors.dark0};
  padding: ${tokens.spacing.insetMedium};
  border-radius: ${tokens.radius.radius_10}px;
  display: flex;

  span {
    margin-right: ${tokens.spacing.horizontalXsmall};
  }

  p {
    padding: 0;
    margin: 0;
    font-size: ${tokens.fontSize.small};
    font-weight: ${tokens.fontWeights.bold};
    line-height: ${tokens.lineHeight.medium}%;
    color: ${tokens.colors.dark5};
  }
`

export const SelectWrapper = styled.div`
  div[role='listbox'] {
    min-height: 300px;
    max-height: 40vh;
    overflow: auto;
  }
`
